// extracted by mini-css-extract-plugin
export default {"modalInner":"chatMessage_modalInner__eVQJ-"};